module.exports = __webpack_public_path__ + "static/2024.10.04_Plan_Osiedla_Pogodne-ograniczenie_do_jednego_etapu-9dd4c750d7ab1dd43a6bddf2bfee654a.jpg";